import Tab1 from "./Tab1"

export default Tab1